import { IGetState, TBoardId } from '../../../types/types';
import { Dispatch, ThunkAction } from '../../../types/actions';
import { notificationSettingsPatchRest } from './api/helpers/notificationSettingsPatchRest';

export const notificationSetEnabled = (
    boardId: TBoardId,
    enabled: boolean
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(notificationSettingsPatchRest(boardId, {enabled}));
    };
    return action;
}
